'use client'

import { AlgoliaHit } from '@repo/algolia/types'
import useIdleObserver from '@repo/ui/hooks/useIdleObserver'
import { useInView } from 'motion/react'
import { FunctionComponent, useRef } from 'react'
import { useTelemetry } from '../../providers/TelemetryProvider'

interface Props {
  gridTitle: string
  hits: AlgoliaHit[]
}

const ProductAlgoliaGridTelemetry: FunctionComponent<Props> = ({ gridTitle, hits }) => {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: true, initial: false, amount: 'some' })
  const { trackAlgoliaViewObjectIDsEvent } = useTelemetry()

  useIdleObserver(
    () => {
      if (isInView) {
        trackAlgoliaViewObjectIDsEvent({
          eventName: `View ${gridTitle}`,
          objectIDs: hits.map((hit) => hit.objectID),
        })
      }
    },
    {},
    [isInView, hits, gridTitle],
  )

  return <div ref={ref} aria-hidden={true} inert={true} />
}

export default ProductAlgoliaGridTelemetry
